import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'

type ModalMenuProps = {
  children: React.ReactNode
  title: React.ReactNode | undefined
  open: boolean
  onClose: ()=> void
}
const ModalMenu: React.FC<ModalMenuProps> = ({children, title, open, onClose}) =>
  <Dialog
    open={open}
    onClose={onClose}
    disableEnforceFocus
    sx={{
      '.MuiDialogContent-root': {padding: '10px'},
    }}
    slotProps={{
      paper: {
        sx: {
          maxHeight: '80%',
          minWidth: '480px',
        }
      }
    }}
  >
    <DialogTitle>
      <Box flexGrow={1} mr={5}>
        {title}
      </Box>
      <IconButton
        onClick={onClose}
        aria-label='close'
        sx={{position: 'absolute', right: 12, top: 8}}
      >
        <span className='material-icons'>close</span>
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box
        role='presentation'
        sx={{fontSize: '14pt', overflow: 'auto'}}
      >
        {children}
      </Box>
    </DialogContent>
  </Dialog>
export default ModalMenu
